// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"8f4a8c45","488":"dc2abcc6","814":"a87fb054"}[chunkId] + ".chunk.js";
};